import {
  CellWrapper,
  DisabledTag
} from '@nile/mangifera/src/Pebbles/TicketContainer';
import {
  BackgroundIcon,
  getDownloadURL,
  ALL_MODULES,
  getHeaderValue,
  toast,
  fetchApi
} from '@nile/components';
import React, { useState } from 'react';
import styled from 'styled-components';
import envConfig from '@nile/home/src/Config/env';
import { FormattedMessage, injectIntl } from 'react-intl';
import { cloneDeep } from 'lodash';
import Attachments from '@nile/client_management/src/Components/ClientLogo';
import { SVGIcon } from '@superops/super-icons';

function StageStatusCell(props) {
  const [actionLoading, setActionLoading] = useState(false);
  const { cell, intl, refreshTable } = props;
  const { value } = cell;
  const data = cell.row.original;
  const { logoFileName, accountId } = data;
  const module = ALL_MODULES.clientAvatar;
  const details = {
    fileName: logoFileName,
    clientId: accountId
  };
  const downloadUrl = getDownloadURL({ module, details });
  /* revisit dangerouslySetInnerHTML xss  */

  const uploadLogo = (image, callback) => {
    console.log(image);
    setActionLoading(true);
    const fileData = new FormData();
    image.forEach((doc, idx) => {
      fileData.append(`files`, doc);
    });
    fileData.append('module', 'CLIENT_AVATAR');
    fileData.append(
      'details',
      JSON.stringify({
        clientId: accountId
      })
    );
    const requestOptions = {
      method: 'POST',
      credentials: 'include',
      body: fileData,
      headers: getHeaderValue()
    };
    fetchApi(`${envConfig.fileRoot}/upload`, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((uploadedDocs) => {
        setActionLoading(false);
        if (uploadedDocs?.data?.downloadURL) {
          const newClient = cloneDeep(data);
          newClient.downloadURL = uploadedDocs.data.downloadURL;
          newClient.logoFileName = uploadedDocs.data.fileName;
          // context.updateContext(newClient);
          toast('success', 'Uploaded successfully');
          refreshTable();
        } else {
          toast('error', 'Something went wrong');
        }
        callback();
      });
  };

  return (
    <Attachments
      intl={intl}
      handleUpload={uploadLogo}
      client={data}
      loading={actionLoading}
      description={<FormattedMessage id="client.logo.desc" />}
      height={1080}
      width={1920}
    />
  );

  // return value ? (
  //   <LogoWrap>
  //     <LogoImage src={downloadUrl} url={downloadUrl} />
  //   </LogoWrap>
  // ) : (
  //   <LogoWrap>
  //     <div style={{ opacity: 0.4 }} className="fx center">
  //       <SVGIcon name="ClientLogo" size="lg" />
  //     </div>
  //   </LogoWrap>
  // );
}

export default injectIntl(StageStatusCell);
